import { isKnownBackendErrorKey } from '@/lib/api/exception.ts';

// 5 minut to przypomnienie, nie gwarancja: okno limitu na backendzie ma 15 minut, a bez
// `Retry-After` nie wiemy, kiedy zwolni się slot — kolejne 429 po prostu zacznie odliczanie od nowa.
export const RATE_LIMIT_COOLDOWN_SECONDS = 5 * 60;

export const isEmailVerificationRateLimited = (error: unknown): boolean =>
  isKnownBackendErrorKey(error, 'EMAIL_VERIFICATION_RATE_LIMITED');

export const formatResendCooldown = (seconds: number): string => {
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  const rest = String(seconds % 60).padStart(2, '0');
  return `${minutes}:${rest}`;
};
